import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  style: {"width":"70%"},
  class: "flex m-2 flex-column gap-2"
}
const _hoisted_3 = { class: "flex m-2 flex-column gap-2" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "w-full flex m-2 flex-column gap-2" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex w-full m-2 flex-column gap-2" }
const _hoisted_8 = { class: "flex m-2 flex-column gap-3" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = {
  style: {"width":"77%"},
  class: "flex m-2 flex-column gap-2"
}
const _hoisted_11 = { class: "flex m-2 flex-column gap-2" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = {
  key: 0,
  class: "flex w-full m-2 flex-column gap-2"
}
const _hoisted_14 = {
  key: 1,
  class: "flex w-full m-2 flex-column gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_text = _resolveComponent("p-text")!
  const _component_p_number = _resolveComponent("p-number")!
  const _component_p_calender = _resolveComponent("p-calender")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Address Line 1", -1)),
        _createVNode(_component_p_text, {
          readonly: _ctx.readonly,
          modelValue: _ctx.app.address1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.app.address1) = $event)),
          size: "large"
        }, null, 8, ["readonly", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Address Line 2", -1)),
        _createVNode(_component_p_text, {
          readonly: _ctx.readonly,
          modelValue: _ctx.app.address2,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.app.address2) = $event)),
          size: "large"
        }, null, 8, ["readonly", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Address Line 3", -1)),
        _createVNode(_component_p_text, {
          modelValue: _ctx.app.address3,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.app.address3) = $event)),
          readonly: _ctx.readonly,
          size: "large"
        }, null, 8, ["modelValue", "readonly"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, "City", -1)),
        _createVNode(_component_p_text, {
          size: "large",
          readonly: _ctx.readonly,
          modelValue: _ctx.app.city,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.app.city) = $event)),
          class: "w-full"
        }, null, 8, ["readonly", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[13] || (_cache[13] = _createElementVNode("label", null, "PIN", -1)),
      _createVNode(_component_p_text, {
        size: "large",
        readonly: _ctx.readonly,
        modelValue: _ctx.app.pin,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.app.pin) = $event)),
        class: "w-full"
      }, null, 8, ["readonly", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[14] || (_cache[14] = _createElementVNode("label", null, "District", -1)),
        _createVNode(_component_p_text, {
          modelValue: _ctx.app.district,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.app.district) = $event)),
          class: "w-full"
        }, null, 8, ["modelValue"]),
        _cache[15] || (_cache[15] = _createElementVNode("small", null, "Enter the district of this address.", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[16] || (_cache[16] = _createElementVNode("label", null, "State", -1)),
        _createVNode(_component_p_text, {
          readonly: _ctx.readonly,
          modelValue: _ctx.app.state,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.app.state) = $event)),
          class: "w-full"
        }, null, 8, ["readonly", "modelValue"]),
        _cache[17] || (_cache[17] = _createElementVNode("small", null, "Enter the state this address is in.", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (!_ctx.business)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Years Living there", -1)),
            _createVNode(_component_p_number, {
              suffix: " Years",
              modelValue: _ctx.app.years_staying,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.app.years_staying) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Date moved in", -1)),
            _createVNode(_component_p_calender, {
              modelValue: _ctx.app.date_moved_in,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.app.date_moved_in) = $event)),
              showIcon: "",
              placeholder: "dd/mm/yyyy",
              dateFormat: "dd/mm/yy",
              showButtonBar: "",
              view: "month",
              showOnFocus: false
            }, null, 8, ["modelValue"])
          ]))
    ])
  ], 64))
}